import React from "react";
import useEntity from "../../../hooks/useUser";
import {
    Box, 
    Paper, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Link,
    TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import {ID} from "../../../../types/global.d";
import EntityListHeader from "./UserListHeader";
import EntityListSearch from "./UserListSearch";
import {useLocation} from "react-router";
import UserListPagination from "./UserListPagination";
import * as Api from "../../../apis/User.api";
import { User } from "../../../types/models/User";
import { PrimaryUser } from "../../../types/models/User";
import { usePagination } from '../../../../share';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate.ts";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import { PrimaryMembersGroup } from "../../../../auth/types/models/MembersGroup";
import {useTheme} from "@mui/material/styles";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import UserListItemTools from "./UserListItemTools";
import {useStateSession} from "../../../../hooks/useAuth";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Trans } from "@lingui/react/macro";
import {
    mdiLinkVariant,
} from "@mdi/js";
import {
    StyledFillNavLink,
    ToolbarTableCell,
    BigTableRow,
    BigTableHeaderRow,
    SmallTableRow,
    SmallTableHeaderRow,
    StyledTableCell,
    StyledMdiIcon,
} from "../../../../share/components/styled/Table";
import {OrderBy, OrderDirection} from "../../../../types/global.d";

type IProps = {
    showAdd: boolean,
    email?: string,
    membersGroupId?: ID,
    };

const UserListItem = (props: IProps) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    
    const session = useStateSession()
    const {showAdd, ...query} = props;

    const { page, pageSize, handleChangePage, handleChangePageSize } = usePagination('User')

    
    
    
    
    const [, setSearchInputValue, searchInputTerm] = useSearchDebounce();
    

    const [orderBys, setOrderBys] = React.useState<OrderBy[]>([]);

    const toggleOrder = React.useCallback((name: string) => {
        setOrderBys(prev => {
            const current = prev.find(item => item.name === name)
            return [
                {
                    name,
                    direction: current?.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc
                },
                ...(prev.filter(item => item.name !== name))
            ]
        });
    }, []);

    const { data: dataSimple = {
        items: [],
        totalItems: 0,
        page,
        pageSize,
        numPages: 0
    }, 
        isLoading: isLoadingSimple,
        isFetching: isFetchingSimple,
        refetch: refetchSimple,
    } =
          Api.useGetUserPresentationQuery({
                  list: { page, pageSize },
                  filter: {
                    userGroupIdRefs: (PrimaryMembersGroup.fromQuery(query.membersGroupId)) ? [ PrimaryMembersGroup.fromQuery(query.membersGroupId) ] : [],
                    email: searchInputTerm || '',
                    emailOr: true,
                    orderBys,
                  },
              })
    
    const {data, isLoading, isFetching, refetch} =
        {
                data: dataSimple,
                isLoading: isLoadingSimple,
                isFetching: isFetchingSimple,
                refetch: refetchSimple,
            }

    const routeLocation = useLocation();
    
    const onClickUrl = (entity: User) => routeLocation.pathname.endsWith('users') ?
        `${PrimaryUser.fromEntity(entity).toPath()}`
        :
        `users/${PrimaryUser.fromEntity(entity).toPath()}`

    const onEditUrl = (entity: User) => `${onClickUrl(entity)}/edit`

    
    
    return React.useMemo(() => (
        <Box>
            <Paper>
                <EntityListHeader showAdd={showAdd} {...query}/>
                <EntityListSearch
                    setSearchInputValue={setSearchInputValue}
                    
                    query={query}
                    refetch={refetch}
                />
                <TableContainer>

                    


                    

                    

                    

                    
        
                    
                    {isSmallScreen ?
                        <Table stickyHeader data-testid="User-entity-list" size="small">
                            <TableHead>
                                <SmallTableHeaderRow>
                                    
                                    

                                    
                            <StyledTableCell align="left">
                                
                                <TableSortLabel
                                    active={ orderBys.find((item) => item.name === 'email') }
                                    direction={ orderBys.find((item) => item.name === 'email')?.direction || 'asc' }
                                    onClick={() => toggleOrder('email')}
                                >
                                
                                    <Trans>Email</Trans>
                                
                                </TableSortLabel>
                                
                            </StyledTableCell>
                        
                    
                                    
                                    
                            <StyledTableCell align="center">
                                
                                <TableSortLabel
                                    active={ orderBys.find((item) => item.name === 'activated') }
                                    direction={ orderBys.find((item) => item.name === 'activated')?.direction || 'asc' }
                                    onClick={() => toggleOrder('activated')}
                                >
                                
                                    <Trans>Activated</Trans>
                                
                                </TableSortLabel>
                                
                            </StyledTableCell>
                        
                    
                                    
                                    
                                </SmallTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <SmallTableRow
                                        hover={true}
                                        key={ PrimaryUser.fromEntity(item).toPath() }
                                    >
                                        
                        
                        
                        

                        <TableCell
                            scope="row"
                            align="left"
                        >
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                                <Typography component="div" sx={ { fontWeight: 'bold', } }>
                                    { item.email ?
                                        <>
                                            
                        
                        { item.email || '-' }
                        
                    
                                        </>
                                        :
                                        '-'
                                    }
                                </Typography>
                                
                            
                            </Link>
                        </TableCell>

                    
                        
                    
                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.activated ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                        
                    
                        
                    
                                    </SmallTableRow>
                                ))}
                            </TableBody>
                        </Table>
                        :
                    
                        <Table stickyHeader data-testid="User-entity-list" size="small">
                            <TableHead>
                                <BigTableHeaderRow>
                                    
                                    
                                    
                                    <StyledTableCell align="left">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'email') }
                                            direction={ orderBys.find((item) => item.name === 'email')?.direction || 'asc' }
                                            onClick={() => toggleOrder('email')}
                                        >
                                        
                                            <Trans>Email</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'activated') }
                                            direction={ orderBys.find((item) => item.name === 'activated')?.direction || 'asc' }
                                            onClick={() => toggleOrder('activated')}
                                        >
                                        
                                            <Trans>Activated</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'banned') }
                                            direction={ orderBys.find((item) => item.name === 'banned')?.direction || 'asc' }
                                            onClick={() => toggleOrder('banned')}
                                        >
                                        
                                            <Trans>Banned</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    <StyledTableCell align="center">
                                        
                                        <TableSortLabel
                                            active={ orderBys.find((item) => item.name === 'createdAt') }
                                            direction={ orderBys.find((item) => item.name === 'createdAt')?.direction || 'asc' }
                                            onClick={() => toggleOrder('createdAt')}
                                        >
                                        
                                            <Trans>Created At</Trans>
                                        
                                        </TableSortLabel>
                                        
                                    </StyledTableCell>
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                    
                                </BigTableHeaderRow>
                            </TableHead>
                            <TableBody>
                                { data.items.map((item) => (
                                    <BigTableRow
                                        hover={true}
                                        key={ PrimaryUser.fromEntity(item).toPath() }
                                    >
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="left"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.email || '-' }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.activated ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        { item.banned ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                        <TableCell
                            scope="row"
                            align="center"
                            
                        >
                            
                            <Link
                                component={StyledFillNavLink}
                                to={ onClickUrl(item) }
                                viewTransition={true}
                            >
                            
                            
                        
                        {displayDateTime(item.createdAt) }
                        
                    
                            
                            </Link>
                            
                        </TableCell>
                        
                    
                                        
                                        
                                        
                                        
                                        
                                        
                                        
                                        <ToolbarTableCell align="center" width="15%">
                                            <UserListItemTools data={ item }
                                                                               onClickUrl={onClickUrl(item)} onEditUrl={onEditUrl(item)}
                                                                                />
                                        </ToolbarTableCell>
                                    </BigTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                    
            
                    { !data.totalItems && !isLoading && !isFetching &&
                        <Typography
                            sx={ { flex: '1 1 100%', padding: "2em", } }
                            component="div"
                        >
                            <Trans>No Users</Trans>
                        </Typography>
                    }
                    { (isLoading || isFetching) &&
                        <GradientCircularProgress/>
                    }
                </TableContainer>
                <UserListPagination
                    totalItems={ data.totalItems }
                    page={Number(page)}
                    pageSize={pageSize}
                    handleChangePage={handleChangePage}
                    handleChangePageSize={handleChangePageSize}
                />
            </Paper>
        </Box>
    ), [isLoading, isFetching,isSmallScreen, data, page, pageSize, onClickUrl,  onEditUrl])
}

export default UserListItem;
